import isWebView from 'is-ua-webview';
import isMobile from 'is-mobile';
import { browserSupportsWebAuthn } from '@simplewebauthn/browser';

export const isInWebView = () => {
  return isWebView(navigator.userAgent);
};

export const isMobileDevice = () => {
  const isPotentiallyIpadWebView = !!navigator && navigator.userAgent.includes('Mac') && 'ontouchend' in document;
  return isMobile({ tablet: true, featureDetect: true }) || isPotentiallyIpadWebView;
};

export const isWebAuthSupported = () => {
  return browserSupportsWebAuthn() && !isInWebView();
};

export const isPasskeySupported = () => {
  return isMobileDevice() && isWebAuthSupported();
};
